module.exports = __webpack_public_path__ + "static/img_pledge_interview_03-f8991cbeef9eb862b6d83bce22a428b6.png";